import { useGetTheme } from '@pba/react-theme';
import { isOneOf } from '@pba/react-utils';
import { useCallback } from 'react';
import type { ReactComponentsCustomThemeConfig } from '../../../theme/default-theme';

export type AvatarSize = keyof ReactComponentsCustomThemeConfig['reactComponents']['avatar']['size'];

const avatarSizes: AvatarSize[] = ['lg', 'md', 'sm', 'xl', 'xs', 'xxl', 'xxxl'];

export const isAvatarSize = (value: unknown): value is AvatarSize => isOneOf(value, avatarSizes);

export const useResolveAvatarSize = () => {
  const { reactComponents } = useGetTheme();

  return useCallback(
    ({ value }: { value: AvatarSize | number }): number => {
      if (typeof value === 'number') {
        return value;
      }

      if (isAvatarSize(value)) {
        return reactComponents.avatar.size[value].value;
      }

      return reactComponents.avatar.size.md.value;
    },
    [reactComponents],
  );
};
